export default "//cdn.scentbird.com/assets/frontbird-site/images/woods_a314b4.jpg";